// The manifests for these apps are saved statically in the Glide builder
// Run this command at root to update the data file:
//
//   > npm run download-sample-app-manifests
//
// This command is run on build to update the data, so changes to app names,
// icons, etc. are updated on deploy. We should replace all of this with
// a faster API for retrieving app manifests.
//
export const sampleAppIds = [
    // Employees
    "2YVx8wLq6B2JDEqcCW6K",

    // Conference
    "IkAlga5wdEbuiiOXXojD",

    // City Guide
    "s7vSDoq2GfcOd4CCCcpu",

    // FInstagram
    "G9CJOMGF4f7nZkB2HQUC",

    // Showcase
    "RP4etTcaMDssWTOwTrPN",

    // UMÉ Studio
    "ERZIYox7Qo5KKoFHF3r5",

    // Issue Tracker
    "tE1I6cDrwVWRp7ojmVrZ",

    // Expense Reporter
    "kK5lOJt42QlS8P58A0uK",

    // Simple CRM
    "kP9vEwI83zJawr4nKdu2"
];
